import React from 'react';
import _ListCategoryBanner from './_ListCategoryBanner.scss';

class ListCategoryBanner extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [
        {image: require('assets/images/banner-category.png'), link: '#'},
        {image: require('assets/images/category_1.png'), link: '#'},
        {image: require('assets/images/category_2.png'), link: '#'},
        {image: require('assets/images/category_3.png'), link: '#'},
        {image: require('assets/images/category_4.png'), link: '#'}
      ]
    }
  }

  render() {
    return (
      <section className="center list-category-banner">
        {
          this.state.data.map((item, index) => {
            return(
              <div className='item-banner' style={{ backgroundImage: `url(${item.image})`}} key={index} >
                <a href={item.link} className='item-link'>
                  <img src={require('assets/images/banner-category.png')} alt='Banner category' className='item-image' />
                </a>
              </div>
            )
          })
        }
      </section>
    );
  }
}

export default ListCategoryBanner;



// WEBPACK FOOTER //
// ./components/home/sub-view/ListCategoryBanner.jsx